import React, { useState ,useEffect } from "react";
import "./css/Booking.css";
import img1 from "../assets/gallery/A1.jpg";

const Booking = () => {
  const [showBooking, setShowBooking] = useState(false);
  const [currentTab, setCurrentTab] = useState(1); // State for tab navigation
  const [bookingType, setBookingType] = useState(""); // To handle dynamic form changes
  const [currentDate, setCurrentDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    bookingType: "",
    adults: "",
    children: "",
    checkIn: "",
    checkOut: "",
    roomType: "",
    numberOfRooms: "",
    timeSlot: "", // For Dayouting
    mealPlan: "", // For FullBoard/HalfBoard
    dateOfVisit: "", // For Dayouting
    includeRoom: false, // For Dayouting
    specialRequest: "", // For both
  });

  const resetForm = () => {
    setFormData({
      fullName: "",
    email: "",
    phone: "",
    bookingType: "",
    adults: "",
    children: "",
    checkIn: "",
    checkOut: "",
    roomType: "",
    numberOfRooms: "",
    timeSlot: "", // For Dayouting
    mealPlan: "", 
    dateOfVisit: "",
    includeRoom: false, 
    specialRequest: "",
    });
  };

  const openWhatsApp = () => {
    const phoneNumber = "+94721404665"; // Updated phone number
    const url = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, "")}`;
    window.open(url, "_blank"); // Opens WhatsApp in a new tab
  };

// Set up the current date and max date for the date picker
useEffect(() => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // Current month (0-based, so +1)

  // Format current date
  const formattedCurrentDate = today.toISOString().split("T")[0];
  setCurrentDate(formattedCurrentDate);

  // Get last day of next month
  const nextMonthLastDay = new Date(year, month + 1, 0); // Next month, day 0 gives last day of previous month
  const maxYear = nextMonthLastDay.getFullYear();
  const maxMonth = (nextMonthLastDay.getMonth() + 1).toString().padStart(2, '0');
  const maxDay = nextMonthLastDay.getDate().toString().padStart(2, '0');

  const formattedMaxDate = `${maxYear}-${maxMonth}-${maxDay}`;
  setMaxDate(formattedMaxDate);


  const totalGuests = Number(formData.adults) + Number(formData.children);
      if (totalGuests > 14) {
        setFormData((prev) => ({ ...prev, includeRoom: true }));
      }
}, [formData.adults, formData.children]);

  const handleBookingClick = () => {
    setShowBooking(true);
    document.body.classList.add("no-scroll");
  };

  const handleCloseClick = () => {
    setShowBooking(false);
    document.body.classList.remove("no-scroll");
    setCurrentTab(1); // Reset to first tab
    setBookingType(""); // Reset booking type
  };

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value,
    }));


  
  

    // Update booking type for dynamic form
    if (id === "bookingType") {
      setBookingType(value);
    }
  };

  const handleNextTab = () => {
    setCurrentTab(2); // Move to Booking Information tab
  };

  const handleBackTab = () => {
    setCurrentTab(1); // Move to Booking Information tab
  };
  

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Determine which PDF to download
  let pdfFile = "";
  if (formData.bookingType === "Dayouting") {
    pdfFile = require("../assets/Day Outing Packages Bolagala Nature Resort.pdf");
  } else if (formData.bookingType === "FullBoard") {
    pdfFile = require("../assets/Full Board Packages Bolagala Nature Resort.pdf"); // Update with the correct file path
  } else if (formData.bookingType === "HalfBoard") {
    pdfFile = require("../assets/Full Board Packages Bolagala Nature Resort.pdf"); // Update with the correct file path
  }

  // Trigger PDF download and open
  if (pdfFile) {
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = pdfFile.split("/").pop(); // Extracts file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Open the PDF in a new tab
    window.open(pdfFile, "_blank");
  }

  // Proceed with form submission (e.g., sending email or WhatsApp message)
  console.log("Form submitted", formData);

    // Prepare the email content
    const emailData = {
      to_name: "Pamith",
      from_name: formData.fullName,
      message: `
        Full Name: ${formData.fullName}
        Email: ${formData.email}
        Phone: ${formData.phone}
        Booking Type: ${formData.bookingType}
        ${bookingType === "Dayouting" ? `Date of Visit: ${formData.dateOfVisit}` : ""}
        ${
          bookingType === "Dayouting" && formData.includeRoom
            ? `Include Room: Yes`
            : `Include Room: No`
        }
        ${
          bookingType === "FullBoard" || bookingType === "HalfBoard"
            ? `Check-In: ${formData.checkIn}`
            : ""
        }
        ${
          bookingType === "FullBoard" || bookingType === "HalfBoard"
            ? `Check-Out: ${formData.checkOut}`
            : ""
        }
        Adults: ${formData.adults}
        Children: ${formData.children || "N/A"}
        Room Type: ${formData.roomType}
        Number of Rooms: ${formData.numberOfRooms}
        Special Request: ${formData.specialRequest}
      `,
    };

    // Send email using EmailJS
    await fetch("https://api.emailjs.com/api/v1.0/email/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        service_id: "service_c297lma", // Replace with your EmailJS service ID
        template_id: "template_tjyzb4j", // Replace with your EmailJS template ID
        user_id: "h30Wcleua9RYOXuPu", // Replace with your EmailJS user ID
        template_params: emailData,
      }),
    });

    // Send WhatsApp message
    const whatsappMessage = `
      Full Name: ${formData.fullName}
      Email: ${formData.email}
      Phone: ${formData.phone}
      Booking Type: ${formData.bookingType}
      ${bookingType === "Dayouting" ? `Date of Visit: ${formData.dateOfVisit}` : ""}
      ${
        bookingType === "Dayouting" && formData.includeRoom
          ? `Include Room: Yes`
          : `Include Room: No`
      }
      ${
        bookingType === "FullBoard" || bookingType === "HalfBoard"
          ? `Check-In: ${formData.checkIn}`
          : ""
      }
      ${
        bookingType === "FullBoard" || bookingType === "HalfBoard"
          ? `Check-Out: ${formData.checkOut}`
          : ""
      }
      Adults: ${formData.adults}
      Children: ${formData.children || "N/A"}
      Room Type: ${formData.roomType}
      Number of Rooms: ${formData.numberOfRooms}
      Special Request: ${formData.specialRequest}
    `;

    const phoneNumber = "+94713677499";
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(
      /[^0-9]/g,
      ""
    )}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, "_blank");

    // Reset form and close booking form
    handleCloseClick();
    resetForm();

  };

  return (
    <div>
         {/* WhatsApp Button */}
         <button className="Btn" onClick={openWhatsApp}>
        <div className="sign">
          <svg className="socialSvg whatsappSvg" viewBox="0 0 16 16">
            <path
              d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
            ></path>
          </svg>
        </div>
        <div className="text">. WhatsApp</div>
      </button>
      <button className="cssbuttons-io-button" onClick={handleBookingClick}>
        BOOK NOW
        <div className="icon">
          <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path
              d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </button>

      {showBooking && (
        <div className="bookcon">
          <div className="booking-container">
            <div className="overlay-background"></div>
            <div className="image-section">
              <img src={img1} alt="Resort view" className="resort-image" />
            </div>
            <div className="form-section">
              
              
              {currentTab === 1 && (
                <form className="booking-form" onSubmit={handleNextTab}>
                  <div className="hedderbuttonpi">
                    <div className="closebutton">
                      <button onClick={() => { handleCloseClick(); resetForm(); }}>X</button>
                    </div>
                  </div>
                  <h2 className="form-title">Personal Informations</h2>
                  <label htmlFor="fullName">Full Name</label>
                  <input
                    type="text"
                    id="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                  />
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                    required
                  />
                  <label htmlFor="bookingType">Booking Type</label>
                  <select
                    id="bookingType"
                    value={formData.bookingType}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled >Select booking type</option>
                    <option value="Dayouting">Dayouting</option>
                    <option value="FullBoard">FullBoard</option>
                    <option value="HalfBoard">HalfBoard</option>
                  </select>
                  <button type="submit" className="next-button">
                    Next
                  </button>
                </form>
              )}
              {currentTab === 2 && (
                <form className="booking-form" onSubmit={handleFormSubmit}>
                  {bookingType === "Dayouting" && (
                    <>
                    <div className="hedderbuttonbi">
                      <div className="backbutton">
                        <button onClick={handleBackTab}>Back</button>
                      </div>
                      <div className="closebutton">
                        <button onClick={() => { handleCloseClick(); resetForm(); }}>X</button>
                      </div>
                    </div>
                      <h2 className="form-title">Booking Informations</h2>
                      <label htmlFor="dateOfVisit">Date of Visit</label>
                      <input
                        type="date"
                        id="dateOfVisit"
                        value={formData.dateOfVisit}
                        onChange={handleChange}
                        min={currentDate} 
                        max={maxDate} 
                        required
                      />
                      <div className="NOfguest">
                      <label htmlFor="adults">Adults</label>
                      <input
                        type="number"
                        id="adults"
                        value={formData.adults}
                        onChange={handleChange}
                        placeholder="Enter number of adults"
                        min="0"
                        max="100"
                        required
                        onInput={(e) => {
                          if (e.target.value < 0) e.target.value = 0; 
                          if (e.target.value > 100) e.target.value = 100;
                        }}
                      />
                      <label htmlFor="children">Children</label>
                      <input
                        type="number"
                        id="children"
                        value={formData.children}
                        onChange={handleChange}
                        placeholder="Between 5-10 years"
                        min="0"
                        max="100"
                        onInput={(e) => {
                          if (e.target.value < 0) e.target.value = 0; 
                          if (e.target.value > 100) e.target.value = 100;
                        }}
                      />
                      </div>
                      <div className="includeR">
                        <label htmlFor="includeRoom">Include Rooms</label>
                        <input
                          type="checkbox"
                          id="includeRoom"
                          checked={formData.includeRoom}
                          disabled={Number(formData.adults) + Number(formData.children) > 14}
                          onChange={handleChange}
                        />
                      </div>
                      <label htmlFor="specialRequest">Special Request</label>
                      <textarea
                        id="specialRequest"
                        value={formData.specialRequest}
                        onChange={handleChange}
                        placeholder="Enter your special request"
                      />
                    </>
                  )}
                  {(bookingType === "FullBoard" || bookingType === "HalfBoard") && (
                    <>
                      <div className="hedderbuttonbi">
                        <div className="backbutton">
                          <button onClick={handleBackTab}>Back</button>
                        </div>
                        <div className="closebutton">
                          <button onClick={() => { handleCloseClick(); resetForm(); }}>X</button>
                        </div>
                      </div>
                      <h2 className="form-title">Booking Informations</h2>
                      <div className="chechdate">
                        <label htmlFor="checkIn">Check-In</label>
                        <input
                          type="date"
                          id="checkIn"
                          value={formData.checkIn}
                          onChange={handleChange}
                          min={currentDate} 
                          max={maxDate} 
                          required
                        />
                        <label htmlFor="checkOut">Check-Out</label>
                        <input
                          type="date"
                          id="checkOut"
                          value={formData.checkOut}
                          onChange={handleChange}
                          min={currentDate} 
                          max={maxDate} 
                          required
                        />
                      </div>
                      <div className="NOfguest FbHbGuest">
                      <label htmlFor="adults">Adults</label>
                      <input
                        type="number"
                        id="adults"
                        value={formData.adults}
                        onChange={handleChange}
                        placeholder="above 10 years"
                        min="0"
                        max="100"
                        required
                        onInput={(e) => {
                          if (e.target.value < 0) e.target.value = 0; 
                          if (e.target.value > 100) e.target.value = 100;
                        }}
                      />

                      <label htmlFor="children">Children</label>
                      <input
                        type="number"
                        id="children"
                        value={formData.children}
                        onChange={handleChange}
                        placeholder="below 10 years"
                        min="0"
                        max="100"
                        onInput={(e) => {
                          if (e.target.value < 0) e.target.value = 0; 
                          if (e.target.value > 100) e.target.value = 100;
                        }}
                      />

                      </div>
                      <label htmlFor="roomType">Room Type</label>
                      <select
                        id="roomType"
                        value={formData.roomType}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>Select room type</option>
                        <option value="Deluxe Room">Deluxe Room</option>
                        <option value="Family Room">Family Room</option>
                      </select>
                      <label htmlFor="specialRequest">Special Request</label>
                      <textarea
                        id="specialRequest"
                        value={formData.specialRequest}
                        onChange={handleChange}
                        placeholder="Enter your special request"
                      />
                    </>
                  )}
                  <button type="submit" className="submit-button">
                    Submit Booking
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Booking;


